import { resolveTextPosition } from "./textRange.js";

function normalizeText(value) {
  return value.replace(/\s+/g, " ").trim();
}

function wrapRange(paragraph, item) {
  const startPoint = resolveTextPosition(paragraph, item.start);
  const endPoint = resolveTextPosition(paragraph, item.end);

  if (!startPoint || !endPoint) {
    return null;
  }

  const range = document.createRange();
  range.setStart(startPoint.node, startPoint.offset);
  range.setEnd(endPoint.node, endPoint.offset);

  const anchor = document.createElement("span");
  anchor.className = "book-enrichment-anchor";
  anchor.dataset.enrichmentId = item.id;

  try {
    range.surroundContents(anchor);
  } catch (_error) {
    return null;
  }

  return anchor;
}

function unwrapAnchor(anchor) {
  const parent = anchor.parentNode;
  if (!parent) {
    return;
  }

  while (anchor.firstChild) {
    parent.insertBefore(anchor.firstChild, anchor);
  }
  parent.removeChild(anchor);
}

export function applyEnrichmentAnchors(book, dataItems) {
  const grouped = new Map();
  const createdAnchors = [];
  const items = [];
  const sortOrder = new Map();

  dataItems.forEach(function (item, index) {
    sortOrder.set(item.id, index);
    const key = `${item.pageId}::${item.para}`;
    if (!grouped.has(key)) {
      grouped.set(key, []);
    }
    grouped.get(key).push(item);
  });

  grouped.forEach(function (groupItems, key) {
    const [pageId, para] = key.split("::");
    const page = book.querySelector(`#${CSS.escape(pageId)}`);
    const paragraph = page?.querySelector(`p[data-para="${para}"]`);

    if (!paragraph) {
      return;
    }

    groupItems
      .slice()
      .sort(function (left, right) {
        return right.start - left.start;
      })
      .forEach(function (item) {
        const anchor = wrapRange(paragraph, item);
        if (!anchor) {
          return;
        }

        createdAnchors.push(anchor);
        items.push({
          id: item.id,
          pageId: item.pageId,
          para: item.para,
          anchor,
          quote: normalizeText(anchor.textContent || ""),
          asset: item,
        });
      });
  });

  items.sort(function (left, right) {
    return sortOrder.get(left.id) - sortOrder.get(right.id);
  });

  return {
    items,
    cleanup() {
      createdAnchors.reverse().forEach(unwrapAnchor);
    },
  };
}

export function getItemSourceY(item) {
  const anchorRect = item.anchor.getBoundingClientRect();
  return window.scrollY + anchorRect.top + anchorRect.height / 2;
}
